import Icon from 'components/Icon/Icon'
import { COLORS } from 'design_system/colors'
import { CommandResultsTemplate } from '../CommandResultsTemplate'

import { ReactComponent as CheckIcon } from 'icons/check-icon.svg'
import { ReactComponent as ErrorIcon } from 'icons/error-icon.svg'
import { rotationEvaluation } from '../commandsUtils'

const heading = 'IN ROTATION'

const ResultTd = ({ userInputForm }) => {
  return (
    <>
      {userInputForm.outRotation === 'false' ? (
        <Icon size="xxs" color={COLORS.powin_green} icon={<CheckIcon />} />
      ) : (
        <Icon size="xxs" color={COLORS.powin_red} icon={<ErrorIcon />} />
      )}
    </>
  )
}

export const ArrayRotationResults = ({ ids, userInputForm }) => {
  return (
    <CommandResultsTemplate
      ids={ids}
      userInputForm={userInputForm}
      pendingEvaluation={rotationEvaluation}
      resultHeading={heading}
      ResultsTd={ResultTd}
      pendingQueryName={'arrayDetailsFunc'}
    />
  )
}
